export const isAcceptedFile = (file: File, acceptedTypes: string[]): boolean =>
  acceptedTypes.some((accepted) => (accepted.startsWith('.') ? file.name.toLowerCase().endsWith(accepted) : file.type === accepted));
